import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";

import { Header, Loading, MainColorButton } from "../../components";
import { bottomButton } from "../../common/styles";
import store from "../../store";
import { getSpecifiedCommercial } from "../../server/axios";

/**
 * 特定商取引法に基づく表記
 * @returns
 */
const SpecifiedCommercial = () => {
  const [endY, setEndY] = useState(0);
  const navigate = useNavigate();

  const [loadingOpen, setLoadingOpen] = useState(false);
  //選択されたを保存
  const [specifiedCommercial, setSpecifiedCommercial] = useState({
    sctlPhamacyName: "",
    sctlRepresentative: "",
    sctlLocation: "",
    sctlPhone: "",
    sctlMailAddress: "",
    sctlPaymentMethod: "",
    sctlDeliveryTime: "",
    sctlReturnsExchanges: "",
  });

  const pharmacySelectedState = (state) => state.prescription.pharmacySelected;
  let pharmacySelected = pharmacySelectedState(store.getState());

  useEffect(() => {
    setLoadingOpen(true);
    getSpecifiedCommercial({
      tenantId: pharmacySelected.selectedRows.tenantId,
    }).then((res) => {
      setSpecifiedCommercial({
        sctlPhamacyName: res.data.target.sctlPhamacyName,
        sctlRepresentative: res.data.target.sctlRepresentative,
        sctlLocation: res.data.target.sctlLocation,
        sctlPhone: res.data.target.sctlPhone,
        sctlMailAddress: res.data.target.sctlMailAddress,
        sctlPaymentMethod: res.data.target.sctlPaymentMethod,
        sctlDeliveryTime: res.data.target.sctlDeliveryTime,
        sctlReturnsExchanges: res.data.target.sctlReturnsExchanges,
      });
      setLoadingOpen(false);
    });
  }, []);

  return (
    <>
      <Loading open={loadingOpen} />
      <div
        onTouchStartCapture={(e) => {
          setEndY(0);
        }}
        onTouchMoveCapture={(e) => {
          setEndY(e.touches[0].clientY);
        }}
        onTouchEndCapture={(e) => {
          if (endY !== 0) {
            e.stopPropagation();
          }
        }}
      >
        <Header title="特定商取引法に基づく表記" />
        <Box
          sx={{ height: "76vh", overflow: "scroll" }}
          marginTop="12vh"
          width="90%"
          marginLeft="auto"
          marginRight="auto"
        >
          <Stack>
            <TableContainer
              component={Paper}
              elevation={0}
              variant="outlined"
              sx={{ width: "auto" }}
            >
              <Table sx={{ border: "1px solid black" }}>
                <TableBody>
                  <TableRow>
                    <TableCell
                      align="left"
                      sx={{
                        border: "1px solid black",
                        padding: "2.5%",
                        width: "30%",
                      }}
                    >
                      薬局名
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      {specifiedCommercial.sctlPhamacyName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      代表者
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      {specifiedCommercial.sctlRepresentative}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      所在地
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      {specifiedCommercial.sctlLocation}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      電話番号
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      {specifiedCommercial.sctlPhone}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      E-MAIL
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      {specifiedCommercial.sctlMailAddress}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      支払い方法
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      {specifiedCommercial.sctlPaymentMethod}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      商品引き渡し時期
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      {specifiedCommercial.sctlDeliveryTime}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      返品・交換について
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ border: "1px solid black", padding: "2.5%" }}
                    >
                      {specifiedCommercial.sctlReturnsExchanges}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Stack>
        </Box>
        <MainColorButton
          label="戻る"
          onClick={() => navigate(-1)}
          style={bottomButton}
        />
      </div>
    </>
  );
};

export default SpecifiedCommercial;
